import React, {
  useEffect
} from 'react';

interface Props {}

const TechnicianProfile: React.FC<Props> = (props) => {
  useEffect(() => {

  }, []);

  return (
    <>
      <div>Profile</div>
    </>
  )
}

export default TechnicianProfile;
